import React from "react";
import Input from "../../../../Components/Common/Input";
import ImageSelector from "../../../../Components/Common/ImageSelector";
import { CategoryApiUrls } from "../../../../Api/Auth/ApiUrls";
import useSWR from "swr";
import Selector from "../../../../Components/Common/Selector";
import HtmlEditor from "../../../../Components/Common/HtmlEditor";

const NewsForm = ({
  onChange,
  handleSubmit,
  errors,
  formData,
  setModalOpen,
}) => {
  const { isLoading, data } = useSWR(CategoryApiUrls.list);
  return (
    <>
      <form onSubmit={handleSubmit} className="flex flex-col gap-2">
        <Input
          label="Title"
          type="text"
          name="title"
          value={formData.title}
          onChange={onChange}
          placeholder="Enter news title"
          error={errors.title}
          required
        />
        <HtmlEditor
          label="Description"
          name="description"
          value={formData.description}
          onChange={onChange}
          placeholder="Enter news description"
          error={errors.description}
          required
        />
        <Input
          label="Slug"
          type="text"
          name="slug"
          value={formData.slug}
          onChange={onChange}
          placeholder="Enter slug"
          error={errors.slug}
          required
        />

        <Selector
          name="category"
          label="Category"
          value={formData?.category}
          options={data?.data?.map((item) => ({
            label: item.title,
            value: item._id,
          }))}
          isClearable={false}
          onChange={onChange}
          error={errors?.category}
          isLoading={isLoading}
          required
        />

        <ImageSelector
          label="Select Image"
          name="link"
          setModalOpen={setModalOpen}
          onChange={onChange}
          value={formData.link}
          placeholder="Click to select an image"
          required
          error={errors.link}
        />
      </form>
    </>
  );
};

export default NewsForm;
